import Quill from 'quill';
import 'quill/dist/quill.snow.css';

const Inline = Quill.import('blots/inline');


export const createBlot = (color, blotName, tagName) => {
  class CustomBlot extends Inline {
    static create(value) {
      const node = super.create(value);
      node.setAttribute('style', `color: ${color};`);
      return node;
    }
  }

  CustomBlot.blotName = blotName;
  CustomBlot.tagName = tagName;
  Quill.register(CustomBlot);
};
